import  { createContext, useContext, useState, useCallback } from "react";
import { FiCheckCircle, FiAlertCircle, FiX } from "react-icons/fi";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback(
    (message, type = "success", duration = 3000) => {
      const id = Date.now();
      setToasts((prev) => [...prev, { id, message, type }]);

      const timer = setTimeout(() => {
        removeToast(id);
      }, duration);

      return () => clearTimeout(timer);
    },
    [removeToast]
  );

  const getIcon = (type) => {
    if (type === "success") return <FiCheckCircle className="w-[30px] h-[30px] mr-3" />;
    if (type === "error") return <FiAlertCircle className="w-[30px] h-[30px] mr-3" />;
    return null;
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed top-5 right-5 flex flex-col gap-3 z-[9999]">
        {toasts.map((toast,index) => (
          <div
            key={index}
            className={`flex items-center justify-between px-4 py-5 rounded shadow text-white min-w-[200px] max-w-xs cursor-pointer animate-slideIn border-l-4 transition-all duration-300 hover:opacity-90 ${
              toast.type === "success"
                ? "bg-quaternary border-quaternary"
                : toast.type === "error"
                ? "bg-orange border-orange"
                : "bg-secondary border-secondary"
            }`}
          >
            <div className="flex items-center">
              {getIcon(toast.type)}
              <span className="font-mono text-sm leading-tight">{toast.message}</span>
            </div>
            <button
              onClick={() => removeToast(toast.id)}
              className="ml-3 text-white hover:text-gray-200 transition-colors"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
